import axios from '@axios'

const route = 'configuration/team_config'

export default {
  namespaced: true,
  state: {

  },
  getters: {

  },
  mutations: {

  },
  actions: {
    saveTeamConfig(context, config) {
      return axios.post(route, config)
    },

    loadTeamConfig(context) {
      return axios.get(route)
    },

  },
}
